import { Injectable } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ArticleValidationsService {
  constructor() {}

  checkDuplicateArticles(itemRows: UntypedFormArray): boolean {
    const articles = itemRows.value.map((row: any) =>
      parseInt(row.article.id_articulo),
    );
    const articlesFound = {} as any;
    return articles.some((element: number) => {
      if (articlesFound[element]) {
        return true;
      } else {
        articlesFound[element] = true;
        return false;
      }
    });
  }
}
